(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumira-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ellara-faq .lf-q').forEach(function(btn) {
  btn.addEventListener('click', function() {
    btn.parentElement.classList.toggle('is-open');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumira-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  var roots = document.querySelectorAll('[data-ehd-root]');
  roots.forEach(function(root) {

    /* HEADER HEIGHT SYNC (carried from Phase 1A) */
    function syncHeaderHeight() {
      var h = root.offsetHeight;
      if (h > 0) document.body.style.paddingTop = h + 'px';
    }
    syncHeaderHeight();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', syncHeaderHeight);
    }
    window.addEventListener('resize', syncHeaderHeight);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeaderHeight).catch(function(){});
    }

    /* ANNOUNCE BAR ROTATION (mobile <680px only) */
    var announce = root.querySelector('[data-ehd-announce]');
    var announceItems = announce ? announce.querySelectorAll('.lhd-announce-item') : [];
    var announceTimer = null;
    function mqMobileAnnounce() { return window.matchMedia('(max-width: 680px)').matches; }
    function rotateAnnounce(items, currentIdx) {
      items.forEach(function(it){ it.classList.remove('is-active'); });
      var nextIdx = (currentIdx + 1) % items.length;
      items[nextIdx].classList.add('is-active');
      return nextIdx;
    }
    function setupAnnounceRotation() {
      if (announceTimer) { clearInterval(announceTimer); announceTimer = null; }
      if (!announceItems || announceItems.length < 2) return;
      if (!mqMobileAnnounce()) {
        announceItems.forEach(function(it){ it.classList.add('is-active'); });
        return;
      }
      var i = 0;
      announceItems.forEach(function(it, idx){
        if (idx === 0) it.classList.add('is-active'); else it.classList.remove('is-active');
      });
      announceTimer = setInterval(function(){ i = rotateAnnounce(announceItems, i); }, 4200);
    }
    setupAnnounceRotation();
    var resizeT = null;
    window.addEventListener('resize', function(){
      clearTimeout(resizeT);
      resizeT = setTimeout(setupAnnounceRotation, 150);
    });

    /* DRAWER */
    var burger = root.querySelector('[data-ehd-burger]');
    var drawer = root.querySelector('[data-ehd-drawer]');
    if (!burger || !drawer) return;
    var panel = drawer.querySelector('.lhd-drawer-panel');
    var lastFocused = null;

    function getFocusables() {
      return panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled])');
    }
    function lockScroll() {
      document.documentElement.classList.add('lhd-scroll-locked');
    }
    function unlockScroll() {
      document.documentElement.classList.remove('lhd-scroll-locked');
      syncHeaderHeight();
    }
    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var focusables = getFocusables();
      if (focusables.length === 0) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus(); e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus(); e.preventDefault();
      }
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      trapFocus(e);
    }
    function open() {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      lockScroll();
      document.addEventListener('keydown', onKey);
      setTimeout(function(){
        var f = getFocusables();
        if (f.length) f[0].focus();
      }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      unlockScroll();
      document.removeEventListener('keydown', onKey);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus(); } catch(_) {}
      }
    }

    burger.addEventListener('click', function(e){
      e.preventDefault();
      if (drawer.classList.contains('is-open')) close(); else open();
    });
    drawer.querySelectorAll('[data-ehd-close]').forEach(function(el){
      el.addEventListener('click', function(e){ e.preventDefault(); close(); });
    });
    panel.querySelectorAll('.lhd-drawer-links a, .lhd-drawer-foot a').forEach(function(a){
      a.addEventListener('click', function(){ close(); });
    });
    window.addEventListener('resize', function(){
      if (window.innerWidth >= 881 && drawer.classList.contains('is-open')) close();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumira-hero-bbuy-box"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.ellara-hero').forEach(function(hero) {
    // Thumbnail switching
    hero.querySelectorAll('.lh-thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = thumb.getAttribute('data-thumb-index');
        hero.querySelectorAll('.lh-thumb').forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        hero.querySelectorAll('.lh-main-img').forEach(function(img) { img.classList.remove('is-active'); });
        var match = hero.querySelector('.lh-main-img[data-main-index="' + idx + '"]');
        if (match) match.classList.add('is-active');
      });
    });
    // Quantity stepper
    hero.querySelectorAll('.qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = btn.parentElement.querySelector('.qty-input');
        var current = parseInt(input.value, 10) || 1;
        var change = parseInt(btn.getAttribute('data-qty'), 10) || 0;
        var next = Math.max(1, current + change);
        input.value = next;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumira-sticky-cart"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.querySelector('[data-ellara-stickybar]');
  if (!bar) return;
  var threshold = parseInt(bar.getAttribute('data-trigger'), 10) || 600;
  function update() {
    if (window.scrollY > threshold) {
      if (!bar.classList.contains('is-visible')) {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      }
    } else {
      if (bar.classList.contains('is-visible')) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }
  }
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prelaunch-07-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.ellara-pl-faq').forEach(function(faq){
    faq.querySelectorAll('.plq-q').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = btn.parentElement;
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
